/* eslint-disable @typescript-eslint/no-unused-vars */
import { TETHERING_LINk, UNLIM_3_DEEP_LINk, UNLIM_24_DEEP_LINK } from 'constants/accumulators';
import { UnlimitedAccumulatorButtonType } from 'types/accumulators';
import { ReplenishButtonType, getReplenishLink } from 'utils';

export const getUnlimitedAccumulatorButtonClickHandler =
  ({
    accumulatorButtonType,
    replenishButtonType,
    tariffUrl,
    isSvyazZ,
    isDesktop = false,
    onClick,
  }: {
    accumulatorButtonType: UnlimitedAccumulatorButtonType | null;
    isDesktop?: boolean;
    isSvyazZ: boolean;
    onClick?: () => void;
    replenishButtonType?: ReplenishButtonType;
    tariffUrl: string;
  }) =>
  (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (accumulatorButtonType === 'GbForDay') {
      window.location.href = UNLIM_24_DEEP_LINK;
      return;
    }

    if (accumulatorButtonType === 'Replenishment') {
      window.location.href = getReplenishLink(replenishButtonType, tariffUrl, isSvyazZ);
    }

    if (accumulatorButtonType === 'Tethering') {
      window.location.href = TETHERING_LINk;
    }

    if (accumulatorButtonType === 'Unlim3Available' || accumulatorButtonType === 'Unlim3Cooling') {
      if (isDesktop) {
        onClick?.();
        return;
      }
      window.location.href = UNLIM_3_DEEP_LINk;
    }
  };
